import run from './main.run';
import translationsConfig from './_translations/en';
import config from './main.config';

import bbPublicBookingModule from '../core/entry.module';

import './_templates/booking_payment_modal.html';
import './_templates/edit_booking_modal_form.html';
import './_templates/member_booking_delete_modal.html';
import './_templates/steps-main/main_account.html';
import './_templates/steps/account.html';
import './_templates/steps/login.html';
import './_templates/steps/past_bookings.html';
import './_templates/steps/purchase_history.html';
import './_templates/steps/register.html';
import './_templates/steps/upcoming_bookings.html';

export default angular
    .module('BBMember', [
        'trNgGrid',
        'pascalprecht.translate',
        'ngResource',
        'ngSanitize',
        bbPublicBookingModule,
    ])
    .config(config)
    .config(translationsConfig)
    .run(run)
    .name;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/member/main.module.js